var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundSunglasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 56,
    viewBox: "0 0 135 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.722 19.4757C133.459 14.4264 128.431 11.3488 123.427 12.4789C118.471 4.95309 109.988 0 100.362 0C87.6381 0 76.9633 8.65587 73.6989 20.4375H59.7121C56.4477 8.65587 45.7729 0 33.0489 0C25.0667 0 17.9184 3.41424 12.8669 8.84821C11.8185 8.4635 10.6986 8.19901 9.53106 8.19901C4.26515 8.19901 0 12.5029 0 17.8166C0 21.6397 2.2398 24.9097 5.4327 26.4725C5.40887 26.9534 5.36122 27.4343 5.36122 27.9392C5.36122 43.3755 17.7516 55.8784 33.0489 55.8784C48.3463 55.8784 60.5699 43.5198 60.7367 28.2277H72.6743C72.8411 43.5198 85.16 55.8784 100.362 55.8784C114.587 55.8784 126.287 45.0586 127.859 31.1131C132.934 29.7906 136.008 24.5731 134.698 19.4276L134.722 19.4757Z",
    fill: "#E68C03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1897 47.4631C43.4674 47.4631 51.7991 39.0557 51.7991 28.6847C51.7991 18.3136 43.4674 9.90625 33.1897 9.90625C22.912 9.90625 14.5803 18.3136 14.5803 28.6847C14.5803 39.0557 22.912 47.4631 33.1897 47.4631Z",
    fill: "#6B062D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.217 47.4631C110.495 47.4631 118.826 39.0557 118.826 28.6847C118.826 18.3136 110.495 9.90625 100.217 9.90625C89.9394 9.90625 81.6077 18.3136 81.6077 28.6847C81.6077 39.0557 89.9394 47.4631 100.217 47.4631Z",
    fill: "#6B062D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundSunglasses);
export default __webpack_public_path__ + "static/media/round-sunglasses.942fed28ccce907dea72fc4bfc06bfee.svg";
export { ForwardRef as ReactComponent };